/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as ProtectedRouteRouteImport } from './routes/_protected/route';
import { Route as LoginRouteImport } from './routes/login';
import { Route as RequestAccessRouteImport } from './routes/request-access';
import { Route as StylePreviewRouteImport } from './routes/style-preview';
import { Route as WaitingRouteImport } from './routes/waiting';
import { Route as ProtectedIndexRouteImport } from './routes/_protected/index';
import { Route as ProtectedAccountRouteImport } from './routes/_protected/account';
import { Route as ProtectedAdminRouteRouteImport } from './routes/_protected/admin/route';
import { Route as ProtectedChatRouteRouteImport } from './routes/_protected/chat/route';
import { Route as ProtectedNewsRouteImport } from './routes/_protected/news';
import { Route as ProtectedReportsRouteImport } from './routes/_protected/reports';
import { Route as ProtectedRestrictedRouteRouteImport } from './routes/_protected/restricted/route';
import { Route as ProtectedUpdatesRouteImport } from './routes/_protected/updates';
import { Route as ClaimTokenRouteImport } from './routes/claim/$token';
import { Route as ProtectedAdminIndexRouteImport } from './routes/_protected/admin/index';
import { Route as ProtectedAdminArioRouteRouteImport } from './routes/_protected/admin/ario/route';
import { Route as ProtectedAdminFeedbackRouteImport } from './routes/_protected/admin/feedback';
import { Route as ProtectedAdminFilesRouteImport } from './routes/_protected/admin/files';
import { Route as ProtectedAdminInspectorRouteImport } from './routes/_protected/admin/inspector';
import { Route as ProtectedAdminInviteRouteImport } from './routes/_protected/admin/invite';
import { Route as ProtectedAdminUploadRouteImport } from './routes/_protected/admin/upload';
import { Route as ProtectedAdminUsageRouteImport } from './routes/_protected/admin/usage';
import { Route as ProtectedAdminUsersRouteImport } from './routes/_protected/admin/users';
import { Route as ProtectedArtifactArtifactIdRouteImport } from './routes/_protected/artifact/$artifactId';
import { Route as ProtectedChatConversationIdRouteImport } from './routes/_protected/chat/$conversationId';
import { Route as ProtectedInsightsIndexRouteImport } from './routes/_protected/insights/index';
import { Route as ProtectedOperatorsIndexRouteImport } from './routes/_protected/operators/index';
import { Route as ProtectedOperatorsSlugRouteImport } from './routes/_protected/operators/$slug';
import { Route as ProtectedRegionsIndexRouteImport } from './routes/_protected/regions/index';
import { Route as ProtectedRegionsSlugRouteImport } from './routes/_protected/regions/$slug';
import { Route as ProtectedRestrictedIndexRouteImport } from './routes/_protected/restricted/index';
import { Route as ProtectedRestrictedExperimentsRouteImport } from './routes/_protected/restricted/experiments';
import { Route as ProtectedAdminArioIndexRouteImport } from './routes/_protected/admin/ario/index';
import { Route as ProtectedAdminArioChatRouteImport } from './routes/_protected/admin/ario/chat';
import { Route as ProtectedAdminArioCollectorsRouteImport } from './routes/_protected/admin/ario/collectors';
import { Route as ProtectedAdminArioNewsRouteImport } from './routes/_protected/admin/ario/news';
import { Route as ProtectedAdminArioOutputsRouteImport } from './routes/_protected/admin/ario/outputs';
import { Route as ProtectedAdminArioProcessorsRouteImport } from './routes/_protected/admin/ario/processors';
import { Route as ProtectedAdminArioRunsRouteImport } from './routes/_protected/admin/ario/runs';
import { Route as ProtectedAdminArioSchedulesRouteImport } from './routes/_protected/admin/ario/schedules';
import { Route as ProtectedAdminArioSourcesRouteImport } from './routes/_protected/admin/ario/sources';
import { Route as ProtectedAdminArioWorkflowsRouteImport } from './routes/_protected/admin/ario/workflows';
import { Route as ProtectedAdminAutomationsIndexRouteImport } from './routes/_protected/admin/automations/index';
import { Route as ProtectedAdminAutomationsSplatRouteImport } from './routes/_protected/admin/automations/$';
import { Route as ProtectedAdminInspectorConversationIdRouteImport } from './routes/_protected/admin/inspector_.$conversationId';
import { Route as ProtectedAdminUsersOnboardingRouteImport } from './routes/_protected/admin/users_.onboarding';
import { Route as ProtectedAdminUsersOrganisationsRouteImport } from './routes/_protected/admin/users_.organisations';
import { Route as ProtectedAdminUsersStaffRouteImport } from './routes/_protected/admin/users_.staff';
import { Route as ProtectedAdminUsersSubscribersRouteImport } from './routes/_protected/admin/users_.subscribers';
import { Route as ProtectedInsightsOperatorSlugRouteImport } from './routes/_protected/insights/operator/$slug';
import { Route as ProtectedAdminArioRunsRunIdRouteImport } from './routes/_protected/admin/ario/runs_.$runId';
import { Route as ProtectedAdminArioWorkflowsWorkflowIdRouteImport } from './routes/_protected/admin/ario/workflows_.$workflowId';

const ProtectedRouteRoute = ProtectedRouteRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const RequestAccessRoute = RequestAccessRouteImport.update({
  id: '/request-access',
  path: '/request-access',
  getParentRoute: () => rootRouteImport,
} as any);
const StylePreviewRoute = StylePreviewRouteImport.update({
  id: '/style-preview',
  path: '/style-preview',
  getParentRoute: () => rootRouteImport,
} as any);
const WaitingRoute = WaitingRouteImport.update({
  id: '/waiting',
  path: '/waiting',
  getParentRoute: () => rootRouteImport,
} as any);
const ProtectedIndexRoute = ProtectedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedRouteRoute,
} as any);
const ProtectedAccountRoute = ProtectedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => ProtectedRouteRoute,
} as any);
const ProtectedAdminRouteRoute = ProtectedAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => ProtectedRouteRoute,
} as any);
const ProtectedChatRouteRoute = ProtectedChatRouteRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => ProtectedRouteRoute,
} as any);
const ProtectedNewsRoute = ProtectedNewsRouteImport.update({
  id: '/news',
  path: '/news',
  getParentRoute: () => ProtectedRouteRoute,
} as any);
const ProtectedReportsRoute = ProtectedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => ProtectedRouteRoute,
} as any);
const ProtectedRestrictedRouteRoute =
  ProtectedRestrictedRouteRouteImport.update({
    id: '/restricted',
    path: '/restricted',
    getParentRoute: () => ProtectedRouteRoute,
  } as any);
const ProtectedUpdatesRoute = ProtectedUpdatesRouteImport.update({
  id: '/updates',
  path: '/updates',
  getParentRoute: () => ProtectedRouteRoute,
} as any);
const ClaimTokenRoute = ClaimTokenRouteImport.update({
  id: '/claim/$token',
  path: '/claim/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const ProtectedAdminIndexRoute = ProtectedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedAdminRouteRoute,
} as any);
const ProtectedAdminArioRouteRoute = ProtectedAdminArioRouteRouteImport.update({
  id: '/ario',
  path: '/ario',
  getParentRoute: () => ProtectedAdminRouteRoute,
} as any);
const ProtectedAdminFeedbackRoute = ProtectedAdminFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => ProtectedAdminRouteRoute,
} as any);
const ProtectedAdminFilesRoute = ProtectedAdminFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => ProtectedAdminRouteRoute,
} as any);
const ProtectedAdminInspectorRoute = ProtectedAdminInspectorRouteImport.update({
  id: '/inspector',
  path: '/inspector',
  getParentRoute: () => ProtectedAdminRouteRoute,
} as any);
const ProtectedAdminInviteRoute = ProtectedAdminInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => ProtectedAdminRouteRoute,
} as any);
const ProtectedAdminUploadRoute = ProtectedAdminUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => ProtectedAdminRouteRoute,
} as any);
const ProtectedAdminUsageRoute = ProtectedAdminUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => ProtectedAdminRouteRoute,
} as any);
const ProtectedAdminUsersRoute = ProtectedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => ProtectedAdminRouteRoute,
} as any);
const ProtectedArtifactArtifactIdRoute =
  ProtectedArtifactArtifactIdRouteImport.update({
    id: '/artifact/$artifactId',
    path: '/artifact/$artifactId',
    getParentRoute: () => ProtectedRouteRoute,
  } as any);
const ProtectedChatConversationIdRoute =
  ProtectedChatConversationIdRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => ProtectedChatRouteRoute,
  } as any);
const ProtectedInsightsIndexRoute = ProtectedInsightsIndexRouteImport.update({
  id: '/insights/',
  path: '/insights/',
  getParentRoute: () => ProtectedRouteRoute,
} as any);
const ProtectedOperatorsIndexRoute = ProtectedOperatorsIndexRouteImport.update({
  id: '/operators/',
  path: '/operators/',
  getParentRoute: () => ProtectedRouteRoute,
} as any);
const ProtectedOperatorsSlugRoute = ProtectedOperatorsSlugRouteImport.update({
  id: '/operators/$slug',
  path: '/operators/$slug',
  getParentRoute: () => ProtectedRouteRoute,
} as any);
const ProtectedRegionsIndexRoute = ProtectedRegionsIndexRouteImport.update({
  id: '/regions/',
  path: '/regions/',
  getParentRoute: () => ProtectedRouteRoute,
} as any);
const ProtectedRegionsSlugRoute = ProtectedRegionsSlugRouteImport.update({
  id: '/regions/$slug',
  path: '/regions/$slug',
  getParentRoute: () => ProtectedRouteRoute,
} as any);
const ProtectedRestrictedIndexRoute =
  ProtectedRestrictedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedRestrictedRouteRoute,
  } as any);
const ProtectedRestrictedExperimentsRoute =
  ProtectedRestrictedExperimentsRouteImport.update({
    id: '/experiments',
    path: '/experiments',
    getParentRoute: () => ProtectedRestrictedRouteRoute,
  } as any);
const ProtectedAdminArioIndexRoute = ProtectedAdminArioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedAdminArioRouteRoute,
} as any);
const ProtectedAdminArioChatRoute = ProtectedAdminArioChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => ProtectedAdminArioRouteRoute,
} as any);
const ProtectedAdminArioCollectorsRoute =
  ProtectedAdminArioCollectorsRouteImport.update({
    id: '/collectors',
    path: '/collectors',
    getParentRoute: () => ProtectedAdminArioRouteRoute,
  } as any);
const ProtectedAdminArioNewsRoute = ProtectedAdminArioNewsRouteImport.update({
  id: '/news',
  path: '/news',
  getParentRoute: () => ProtectedAdminArioRouteRoute,
} as any);
const ProtectedAdminArioOutputsRoute =
  ProtectedAdminArioOutputsRouteImport.update({
    id: '/outputs',
    path: '/outputs',
    getParentRoute: () => ProtectedAdminArioRouteRoute,
  } as any);
const ProtectedAdminArioProcessorsRoute =
  ProtectedAdminArioProcessorsRouteImport.update({
    id: '/processors',
    path: '/processors',
    getParentRoute: () => ProtectedAdminArioRouteRoute,
  } as any);
const ProtectedAdminArioRunsRoute = ProtectedAdminArioRunsRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => ProtectedAdminArioRouteRoute,
} as any);
const ProtectedAdminArioSchedulesRoute =
  ProtectedAdminArioSchedulesRouteImport.update({
    id: '/schedules',
    path: '/schedules',
    getParentRoute: () => ProtectedAdminArioRouteRoute,
  } as any);
const ProtectedAdminArioSourcesRoute =
  ProtectedAdminArioSourcesRouteImport.update({
    id: '/sources',
    path: '/sources',
    getParentRoute: () => ProtectedAdminArioRouteRoute,
  } as any);
const ProtectedAdminArioWorkflowsRoute =
  ProtectedAdminArioWorkflowsRouteImport.update({
    id: '/workflows',
    path: '/workflows',
    getParentRoute: () => ProtectedAdminArioRouteRoute,
  } as any);
const ProtectedAdminAutomationsIndexRoute =
  ProtectedAdminAutomationsIndexRouteImport.update({
    id: '/automations/',
    path: '/automations/',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any);
const ProtectedAdminAutomationsSplatRoute =
  ProtectedAdminAutomationsSplatRouteImport.update({
    id: '/automations/$',
    path: '/automations/$',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any);
const ProtectedAdminInspectorConversationIdRoute =
  ProtectedAdminInspectorConversationIdRouteImport.update({
    id: '/inspector_/$conversationId',
    path: '/inspector/$conversationId',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any);
const ProtectedAdminUsersOnboardingRoute =
  ProtectedAdminUsersOnboardingRouteImport.update({
    id: '/users_/onboarding',
    path: '/users/onboarding',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any);
const ProtectedAdminUsersOrganisationsRoute =
  ProtectedAdminUsersOrganisationsRouteImport.update({
    id: '/users_/organisations',
    path: '/users/organisations',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any);
const ProtectedAdminUsersStaffRoute =
  ProtectedAdminUsersStaffRouteImport.update({
    id: '/users_/staff',
    path: '/users/staff',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any);
const ProtectedAdminUsersSubscribersRoute =
  ProtectedAdminUsersSubscribersRouteImport.update({
    id: '/users_/subscribers',
    path: '/users/subscribers',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any);
const ProtectedInsightsOperatorSlugRoute =
  ProtectedInsightsOperatorSlugRouteImport.update({
    id: '/insights/operator/$slug',
    path: '/insights/operator/$slug',
    getParentRoute: () => ProtectedRouteRoute,
  } as any);
const ProtectedAdminArioRunsRunIdRoute =
  ProtectedAdminArioRunsRunIdRouteImport.update({
    id: '/runs_/$runId',
    path: '/runs/$runId',
    getParentRoute: () => ProtectedAdminArioRouteRoute,
  } as any);
const ProtectedAdminArioWorkflowsWorkflowIdRoute =
  ProtectedAdminArioWorkflowsWorkflowIdRouteImport.update({
    id: '/workflows_/$workflowId',
    path: '/workflows/$workflowId',
    getParentRoute: () => ProtectedAdminArioRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof ProtectedIndexRoute;
  '/login': typeof LoginRoute;
  '/request-access': typeof RequestAccessRoute;
  '/style-preview': typeof StylePreviewRoute;
  '/waiting': typeof WaitingRoute;
  '/admin': typeof ProtectedAdminRouteRouteWithChildren;
  '/chat': typeof ProtectedChatRouteRouteWithChildren;
  '/restricted': typeof ProtectedRestrictedRouteRouteWithChildren;
  '/account': typeof ProtectedAccountRoute;
  '/news': typeof ProtectedNewsRoute;
  '/reports': typeof ProtectedReportsRoute;
  '/updates': typeof ProtectedUpdatesRoute;
  '/claim/$token': typeof ClaimTokenRoute;
  '/admin/ario': typeof ProtectedAdminArioRouteRouteWithChildren;
  '/admin/feedback': typeof ProtectedAdminFeedbackRoute;
  '/admin/files': typeof ProtectedAdminFilesRoute;
  '/admin/inspector': typeof ProtectedAdminInspectorRoute;
  '/admin/invite': typeof ProtectedAdminInviteRoute;
  '/admin/upload': typeof ProtectedAdminUploadRoute;
  '/admin/usage': typeof ProtectedAdminUsageRoute;
  '/admin/users': typeof ProtectedAdminUsersRoute;
  '/artifact/$artifactId': typeof ProtectedArtifactArtifactIdRoute;
  '/chat/$conversationId': typeof ProtectedChatConversationIdRoute;
  '/operators/$slug': typeof ProtectedOperatorsSlugRoute;
  '/regions/$slug': typeof ProtectedRegionsSlugRoute;
  '/restricted/experiments': typeof ProtectedRestrictedExperimentsRoute;
  '/admin/': typeof ProtectedAdminIndexRoute;
  '/insights/': typeof ProtectedInsightsIndexRoute;
  '/operators/': typeof ProtectedOperatorsIndexRoute;
  '/regions/': typeof ProtectedRegionsIndexRoute;
  '/restricted/': typeof ProtectedRestrictedIndexRoute;
  '/admin/ario/chat': typeof ProtectedAdminArioChatRoute;
  '/admin/ario/collectors': typeof ProtectedAdminArioCollectorsRoute;
  '/admin/ario/news': typeof ProtectedAdminArioNewsRoute;
  '/admin/ario/outputs': typeof ProtectedAdminArioOutputsRoute;
  '/admin/ario/processors': typeof ProtectedAdminArioProcessorsRoute;
  '/admin/ario/runs': typeof ProtectedAdminArioRunsRoute;
  '/admin/ario/schedules': typeof ProtectedAdminArioSchedulesRoute;
  '/admin/ario/sources': typeof ProtectedAdminArioSourcesRoute;
  '/admin/ario/workflows': typeof ProtectedAdminArioWorkflowsRoute;
  '/admin/automations/$': typeof ProtectedAdminAutomationsSplatRoute;
  '/admin/inspector/$conversationId': typeof ProtectedAdminInspectorConversationIdRoute;
  '/admin/users/onboarding': typeof ProtectedAdminUsersOnboardingRoute;
  '/admin/users/organisations': typeof ProtectedAdminUsersOrganisationsRoute;
  '/admin/users/staff': typeof ProtectedAdminUsersStaffRoute;
  '/admin/users/subscribers': typeof ProtectedAdminUsersSubscribersRoute;
  '/insights/operator/$slug': typeof ProtectedInsightsOperatorSlugRoute;
  '/admin/ario/': typeof ProtectedAdminArioIndexRoute;
  '/admin/automations/': typeof ProtectedAdminAutomationsIndexRoute;
  '/admin/ario/runs/$runId': typeof ProtectedAdminArioRunsRunIdRoute;
  '/admin/ario/workflows/$workflowId': typeof ProtectedAdminArioWorkflowsWorkflowIdRoute;
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute;
  '/request-access': typeof RequestAccessRoute;
  '/style-preview': typeof StylePreviewRoute;
  '/waiting': typeof WaitingRoute;
  '/chat': typeof ProtectedChatRouteRouteWithChildren;
  '/account': typeof ProtectedAccountRoute;
  '/news': typeof ProtectedNewsRoute;
  '/reports': typeof ProtectedReportsRoute;
  '/updates': typeof ProtectedUpdatesRoute;
  '/claim/$token': typeof ClaimTokenRoute;
  '/': typeof ProtectedIndexRoute;
  '/admin/feedback': typeof ProtectedAdminFeedbackRoute;
  '/admin/files': typeof ProtectedAdminFilesRoute;
  '/admin/inspector': typeof ProtectedAdminInspectorRoute;
  '/admin/invite': typeof ProtectedAdminInviteRoute;
  '/admin/upload': typeof ProtectedAdminUploadRoute;
  '/admin/usage': typeof ProtectedAdminUsageRoute;
  '/admin/users': typeof ProtectedAdminUsersRoute;
  '/artifact/$artifactId': typeof ProtectedArtifactArtifactIdRoute;
  '/chat/$conversationId': typeof ProtectedChatConversationIdRoute;
  '/operators/$slug': typeof ProtectedOperatorsSlugRoute;
  '/regions/$slug': typeof ProtectedRegionsSlugRoute;
  '/restricted/experiments': typeof ProtectedRestrictedExperimentsRoute;
  '/admin': typeof ProtectedAdminIndexRoute;
  '/insights': typeof ProtectedInsightsIndexRoute;
  '/operators': typeof ProtectedOperatorsIndexRoute;
  '/regions': typeof ProtectedRegionsIndexRoute;
  '/restricted': typeof ProtectedRestrictedIndexRoute;
  '/admin/ario/chat': typeof ProtectedAdminArioChatRoute;
  '/admin/ario/collectors': typeof ProtectedAdminArioCollectorsRoute;
  '/admin/ario/news': typeof ProtectedAdminArioNewsRoute;
  '/admin/ario/outputs': typeof ProtectedAdminArioOutputsRoute;
  '/admin/ario/processors': typeof ProtectedAdminArioProcessorsRoute;
  '/admin/ario/runs': typeof ProtectedAdminArioRunsRoute;
  '/admin/ario/schedules': typeof ProtectedAdminArioSchedulesRoute;
  '/admin/ario/sources': typeof ProtectedAdminArioSourcesRoute;
  '/admin/ario/workflows': typeof ProtectedAdminArioWorkflowsRoute;
  '/admin/automations/$': typeof ProtectedAdminAutomationsSplatRoute;
  '/admin/inspector/$conversationId': typeof ProtectedAdminInspectorConversationIdRoute;
  '/admin/users/onboarding': typeof ProtectedAdminUsersOnboardingRoute;
  '/admin/users/organisations': typeof ProtectedAdminUsersOrganisationsRoute;
  '/admin/users/staff': typeof ProtectedAdminUsersStaffRoute;
  '/admin/users/subscribers': typeof ProtectedAdminUsersSubscribersRoute;
  '/insights/operator/$slug': typeof ProtectedInsightsOperatorSlugRoute;
  '/admin/ario': typeof ProtectedAdminArioIndexRoute;
  '/admin/automations': typeof ProtectedAdminAutomationsIndexRoute;
  '/admin/ario/runs/$runId': typeof ProtectedAdminArioRunsRunIdRoute;
  '/admin/ario/workflows/$workflowId': typeof ProtectedAdminArioWorkflowsWorkflowIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_protected': typeof ProtectedRouteRouteWithChildren;
  '/login': typeof LoginRoute;
  '/request-access': typeof RequestAccessRoute;
  '/style-preview': typeof StylePreviewRoute;
  '/waiting': typeof WaitingRoute;
  '/_protected/admin': typeof ProtectedAdminRouteRouteWithChildren;
  '/_protected/chat': typeof ProtectedChatRouteRouteWithChildren;
  '/_protected/restricted': typeof ProtectedRestrictedRouteRouteWithChildren;
  '/_protected/account': typeof ProtectedAccountRoute;
  '/_protected/news': typeof ProtectedNewsRoute;
  '/_protected/reports': typeof ProtectedReportsRoute;
  '/_protected/updates': typeof ProtectedUpdatesRoute;
  '/claim/$token': typeof ClaimTokenRoute;
  '/_protected/': typeof ProtectedIndexRoute;
  '/_protected/admin/ario': typeof ProtectedAdminArioRouteRouteWithChildren;
  '/_protected/admin/feedback': typeof ProtectedAdminFeedbackRoute;
  '/_protected/admin/files': typeof ProtectedAdminFilesRoute;
  '/_protected/admin/inspector': typeof ProtectedAdminInspectorRoute;
  '/_protected/admin/invite': typeof ProtectedAdminInviteRoute;
  '/_protected/admin/upload': typeof ProtectedAdminUploadRoute;
  '/_protected/admin/usage': typeof ProtectedAdminUsageRoute;
  '/_protected/admin/users': typeof ProtectedAdminUsersRoute;
  '/_protected/artifact/$artifactId': typeof ProtectedArtifactArtifactIdRoute;
  '/_protected/chat/$conversationId': typeof ProtectedChatConversationIdRoute;
  '/_protected/operators/$slug': typeof ProtectedOperatorsSlugRoute;
  '/_protected/regions/$slug': typeof ProtectedRegionsSlugRoute;
  '/_protected/restricted/experiments': typeof ProtectedRestrictedExperimentsRoute;
  '/_protected/admin/': typeof ProtectedAdminIndexRoute;
  '/_protected/insights/': typeof ProtectedInsightsIndexRoute;
  '/_protected/operators/': typeof ProtectedOperatorsIndexRoute;
  '/_protected/regions/': typeof ProtectedRegionsIndexRoute;
  '/_protected/restricted/': typeof ProtectedRestrictedIndexRoute;
  '/_protected/admin/ario/chat': typeof ProtectedAdminArioChatRoute;
  '/_protected/admin/ario/collectors': typeof ProtectedAdminArioCollectorsRoute;
  '/_protected/admin/ario/news': typeof ProtectedAdminArioNewsRoute;
  '/_protected/admin/ario/outputs': typeof ProtectedAdminArioOutputsRoute;
  '/_protected/admin/ario/processors': typeof ProtectedAdminArioProcessorsRoute;
  '/_protected/admin/ario/runs': typeof ProtectedAdminArioRunsRoute;
  '/_protected/admin/ario/schedules': typeof ProtectedAdminArioSchedulesRoute;
  '/_protected/admin/ario/sources': typeof ProtectedAdminArioSourcesRoute;
  '/_protected/admin/ario/workflows': typeof ProtectedAdminArioWorkflowsRoute;
  '/_protected/admin/automations/$': typeof ProtectedAdminAutomationsSplatRoute;
  '/_protected/admin/inspector_/$conversationId': typeof ProtectedAdminInspectorConversationIdRoute;
  '/_protected/admin/users_/onboarding': typeof ProtectedAdminUsersOnboardingRoute;
  '/_protected/admin/users_/organisations': typeof ProtectedAdminUsersOrganisationsRoute;
  '/_protected/admin/users_/staff': typeof ProtectedAdminUsersStaffRoute;
  '/_protected/admin/users_/subscribers': typeof ProtectedAdminUsersSubscribersRoute;
  '/_protected/insights/operator/$slug': typeof ProtectedInsightsOperatorSlugRoute;
  '/_protected/admin/ario/': typeof ProtectedAdminArioIndexRoute;
  '/_protected/admin/automations/': typeof ProtectedAdminAutomationsIndexRoute;
  '/_protected/admin/ario/runs_/$runId': typeof ProtectedAdminArioRunsRunIdRoute;
  '/_protected/admin/ario/workflows_/$workflowId': typeof ProtectedAdminArioWorkflowsWorkflowIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/login'
    | '/request-access'
    | '/style-preview'
    | '/waiting'
    | '/admin'
    | '/chat'
    | '/restricted'
    | '/account'
    | '/news'
    | '/reports'
    | '/updates'
    | '/claim/$token'
    | '/admin/ario'
    | '/admin/feedback'
    | '/admin/files'
    | '/admin/inspector'
    | '/admin/invite'
    | '/admin/upload'
    | '/admin/usage'
    | '/admin/users'
    | '/artifact/$artifactId'
    | '/chat/$conversationId'
    | '/operators/$slug'
    | '/regions/$slug'
    | '/restricted/experiments'
    | '/admin/'
    | '/insights/'
    | '/operators/'
    | '/regions/'
    | '/restricted/'
    | '/admin/ario/chat'
    | '/admin/ario/collectors'
    | '/admin/ario/news'
    | '/admin/ario/outputs'
    | '/admin/ario/processors'
    | '/admin/ario/runs'
    | '/admin/ario/schedules'
    | '/admin/ario/sources'
    | '/admin/ario/workflows'
    | '/admin/automations/$'
    | '/admin/inspector/$conversationId'
    | '/admin/users/onboarding'
    | '/admin/users/organisations'
    | '/admin/users/staff'
    | '/admin/users/subscribers'
    | '/insights/operator/$slug'
    | '/admin/ario/'
    | '/admin/automations/'
    | '/admin/ario/runs/$runId'
    | '/admin/ario/workflows/$workflowId';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/login'
    | '/request-access'
    | '/style-preview'
    | '/waiting'
    | '/chat'
    | '/account'
    | '/news'
    | '/reports'
    | '/updates'
    | '/claim/$token'
    | '/'
    | '/admin/feedback'
    | '/admin/files'
    | '/admin/inspector'
    | '/admin/invite'
    | '/admin/upload'
    | '/admin/usage'
    | '/admin/users'
    | '/artifact/$artifactId'
    | '/chat/$conversationId'
    | '/operators/$slug'
    | '/regions/$slug'
    | '/restricted/experiments'
    | '/admin'
    | '/insights'
    | '/operators'
    | '/regions'
    | '/restricted'
    | '/admin/ario/chat'
    | '/admin/ario/collectors'
    | '/admin/ario/news'
    | '/admin/ario/outputs'
    | '/admin/ario/processors'
    | '/admin/ario/runs'
    | '/admin/ario/schedules'
    | '/admin/ario/sources'
    | '/admin/ario/workflows'
    | '/admin/automations/$'
    | '/admin/inspector/$conversationId'
    | '/admin/users/onboarding'
    | '/admin/users/organisations'
    | '/admin/users/staff'
    | '/admin/users/subscribers'
    | '/insights/operator/$slug'
    | '/admin/ario'
    | '/admin/automations'
    | '/admin/ario/runs/$runId'
    | '/admin/ario/workflows/$workflowId';
  id:
    | '__root__'
    | '/_protected'
    | '/login'
    | '/request-access'
    | '/style-preview'
    | '/waiting'
    | '/_protected/admin'
    | '/_protected/chat'
    | '/_protected/restricted'
    | '/_protected/account'
    | '/_protected/news'
    | '/_protected/reports'
    | '/_protected/updates'
    | '/claim/$token'
    | '/_protected/'
    | '/_protected/admin/ario'
    | '/_protected/admin/feedback'
    | '/_protected/admin/files'
    | '/_protected/admin/inspector'
    | '/_protected/admin/invite'
    | '/_protected/admin/upload'
    | '/_protected/admin/usage'
    | '/_protected/admin/users'
    | '/_protected/artifact/$artifactId'
    | '/_protected/chat/$conversationId'
    | '/_protected/operators/$slug'
    | '/_protected/regions/$slug'
    | '/_protected/restricted/experiments'
    | '/_protected/admin/'
    | '/_protected/insights/'
    | '/_protected/operators/'
    | '/_protected/regions/'
    | '/_protected/restricted/'
    | '/_protected/admin/ario/chat'
    | '/_protected/admin/ario/collectors'
    | '/_protected/admin/ario/news'
    | '/_protected/admin/ario/outputs'
    | '/_protected/admin/ario/processors'
    | '/_protected/admin/ario/runs'
    | '/_protected/admin/ario/schedules'
    | '/_protected/admin/ario/sources'
    | '/_protected/admin/ario/workflows'
    | '/_protected/admin/automations/$'
    | '/_protected/admin/inspector_/$conversationId'
    | '/_protected/admin/users_/onboarding'
    | '/_protected/admin/users_/organisations'
    | '/_protected/admin/users_/staff'
    | '/_protected/admin/users_/subscribers'
    | '/_protected/insights/operator/$slug'
    | '/_protected/admin/ario/'
    | '/_protected/admin/automations/'
    | '/_protected/admin/ario/runs_/$runId'
    | '/_protected/admin/ario/workflows_/$workflowId';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  ProtectedRouteRoute: typeof ProtectedRouteRouteWithChildren;
  LoginRoute: typeof LoginRoute;
  RequestAccessRoute: typeof RequestAccessRoute;
  StylePreviewRoute: typeof StylePreviewRoute;
  WaitingRoute: typeof WaitingRoute;
  ClaimTokenRoute: typeof ClaimTokenRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_protected': {
      id: '/_protected';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof ProtectedRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/request-access': {
      id: '/request-access';
      path: '/request-access';
      fullPath: '/request-access';
      preLoaderRoute: typeof RequestAccessRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/style-preview': {
      id: '/style-preview';
      path: '/style-preview';
      fullPath: '/style-preview';
      preLoaderRoute: typeof StylePreviewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/waiting': {
      id: '/waiting';
      path: '/waiting';
      fullPath: '/waiting';
      preLoaderRoute: typeof WaitingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_protected/': {
      id: '/_protected/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof ProtectedIndexRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    '/_protected/account': {
      id: '/_protected/account';
      path: '/account';
      fullPath: '/account';
      preLoaderRoute: typeof ProtectedAccountRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    '/_protected/admin': {
      id: '/_protected/admin';
      path: '/admin';
      fullPath: '/admin';
      preLoaderRoute: typeof ProtectedAdminRouteRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    '/_protected/chat': {
      id: '/_protected/chat';
      path: '/chat';
      fullPath: '/chat';
      preLoaderRoute: typeof ProtectedChatRouteRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    '/_protected/news': {
      id: '/_protected/news';
      path: '/news';
      fullPath: '/news';
      preLoaderRoute: typeof ProtectedNewsRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    '/_protected/reports': {
      id: '/_protected/reports';
      path: '/reports';
      fullPath: '/reports';
      preLoaderRoute: typeof ProtectedReportsRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    '/_protected/restricted': {
      id: '/_protected/restricted';
      path: '/restricted';
      fullPath: '/restricted';
      preLoaderRoute: typeof ProtectedRestrictedRouteRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    '/_protected/updates': {
      id: '/_protected/updates';
      path: '/updates';
      fullPath: '/updates';
      preLoaderRoute: typeof ProtectedUpdatesRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    '/claim/$token': {
      id: '/claim/$token';
      path: '/claim/$token';
      fullPath: '/claim/$token';
      preLoaderRoute: typeof ClaimTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_protected/admin/': {
      id: '/_protected/admin/';
      path: '/';
      fullPath: '/admin/';
      preLoaderRoute: typeof ProtectedAdminIndexRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/admin/ario': {
      id: '/_protected/admin/ario';
      path: '/ario';
      fullPath: '/admin/ario';
      preLoaderRoute: typeof ProtectedAdminArioRouteRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/admin/feedback': {
      id: '/_protected/admin/feedback';
      path: '/feedback';
      fullPath: '/admin/feedback';
      preLoaderRoute: typeof ProtectedAdminFeedbackRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/admin/files': {
      id: '/_protected/admin/files';
      path: '/files';
      fullPath: '/admin/files';
      preLoaderRoute: typeof ProtectedAdminFilesRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/admin/inspector': {
      id: '/_protected/admin/inspector';
      path: '/inspector';
      fullPath: '/admin/inspector';
      preLoaderRoute: typeof ProtectedAdminInspectorRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/admin/invite': {
      id: '/_protected/admin/invite';
      path: '/invite';
      fullPath: '/admin/invite';
      preLoaderRoute: typeof ProtectedAdminInviteRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/admin/upload': {
      id: '/_protected/admin/upload';
      path: '/upload';
      fullPath: '/admin/upload';
      preLoaderRoute: typeof ProtectedAdminUploadRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/admin/usage': {
      id: '/_protected/admin/usage';
      path: '/usage';
      fullPath: '/admin/usage';
      preLoaderRoute: typeof ProtectedAdminUsageRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/admin/users': {
      id: '/_protected/admin/users';
      path: '/users';
      fullPath: '/admin/users';
      preLoaderRoute: typeof ProtectedAdminUsersRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/artifact/$artifactId': {
      id: '/_protected/artifact/$artifactId';
      path: '/artifact/$artifactId';
      fullPath: '/artifact/$artifactId';
      preLoaderRoute: typeof ProtectedArtifactArtifactIdRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    '/_protected/chat/$conversationId': {
      id: '/_protected/chat/$conversationId';
      path: '/$conversationId';
      fullPath: '/chat/$conversationId';
      preLoaderRoute: typeof ProtectedChatConversationIdRouteImport;
      parentRoute: typeof ProtectedChatRouteRoute;
    };
    '/_protected/insights/': {
      id: '/_protected/insights/';
      path: '/insights';
      fullPath: '/insights/';
      preLoaderRoute: typeof ProtectedInsightsIndexRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    '/_protected/operators/': {
      id: '/_protected/operators/';
      path: '/operators';
      fullPath: '/operators/';
      preLoaderRoute: typeof ProtectedOperatorsIndexRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    '/_protected/operators/$slug': {
      id: '/_protected/operators/$slug';
      path: '/operators/$slug';
      fullPath: '/operators/$slug';
      preLoaderRoute: typeof ProtectedOperatorsSlugRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    '/_protected/regions/': {
      id: '/_protected/regions/';
      path: '/regions';
      fullPath: '/regions/';
      preLoaderRoute: typeof ProtectedRegionsIndexRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    '/_protected/regions/$slug': {
      id: '/_protected/regions/$slug';
      path: '/regions/$slug';
      fullPath: '/regions/$slug';
      preLoaderRoute: typeof ProtectedRegionsSlugRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    '/_protected/restricted/': {
      id: '/_protected/restricted/';
      path: '/';
      fullPath: '/restricted/';
      preLoaderRoute: typeof ProtectedRestrictedIndexRouteImport;
      parentRoute: typeof ProtectedRestrictedRouteRoute;
    };
    '/_protected/restricted/experiments': {
      id: '/_protected/restricted/experiments';
      path: '/experiments';
      fullPath: '/restricted/experiments';
      preLoaderRoute: typeof ProtectedRestrictedExperimentsRouteImport;
      parentRoute: typeof ProtectedRestrictedRouteRoute;
    };
    '/_protected/admin/ario/': {
      id: '/_protected/admin/ario/';
      path: '/';
      fullPath: '/admin/ario/';
      preLoaderRoute: typeof ProtectedAdminArioIndexRouteImport;
      parentRoute: typeof ProtectedAdminArioRouteRoute;
    };
    '/_protected/admin/ario/chat': {
      id: '/_protected/admin/ario/chat';
      path: '/chat';
      fullPath: '/admin/ario/chat';
      preLoaderRoute: typeof ProtectedAdminArioChatRouteImport;
      parentRoute: typeof ProtectedAdminArioRouteRoute;
    };
    '/_protected/admin/ario/collectors': {
      id: '/_protected/admin/ario/collectors';
      path: '/collectors';
      fullPath: '/admin/ario/collectors';
      preLoaderRoute: typeof ProtectedAdminArioCollectorsRouteImport;
      parentRoute: typeof ProtectedAdminArioRouteRoute;
    };
    '/_protected/admin/ario/news': {
      id: '/_protected/admin/ario/news';
      path: '/news';
      fullPath: '/admin/ario/news';
      preLoaderRoute: typeof ProtectedAdminArioNewsRouteImport;
      parentRoute: typeof ProtectedAdminArioRouteRoute;
    };
    '/_protected/admin/ario/outputs': {
      id: '/_protected/admin/ario/outputs';
      path: '/outputs';
      fullPath: '/admin/ario/outputs';
      preLoaderRoute: typeof ProtectedAdminArioOutputsRouteImport;
      parentRoute: typeof ProtectedAdminArioRouteRoute;
    };
    '/_protected/admin/ario/processors': {
      id: '/_protected/admin/ario/processors';
      path: '/processors';
      fullPath: '/admin/ario/processors';
      preLoaderRoute: typeof ProtectedAdminArioProcessorsRouteImport;
      parentRoute: typeof ProtectedAdminArioRouteRoute;
    };
    '/_protected/admin/ario/runs': {
      id: '/_protected/admin/ario/runs';
      path: '/runs';
      fullPath: '/admin/ario/runs';
      preLoaderRoute: typeof ProtectedAdminArioRunsRouteImport;
      parentRoute: typeof ProtectedAdminArioRouteRoute;
    };
    '/_protected/admin/ario/schedules': {
      id: '/_protected/admin/ario/schedules';
      path: '/schedules';
      fullPath: '/admin/ario/schedules';
      preLoaderRoute: typeof ProtectedAdminArioSchedulesRouteImport;
      parentRoute: typeof ProtectedAdminArioRouteRoute;
    };
    '/_protected/admin/ario/sources': {
      id: '/_protected/admin/ario/sources';
      path: '/sources';
      fullPath: '/admin/ario/sources';
      preLoaderRoute: typeof ProtectedAdminArioSourcesRouteImport;
      parentRoute: typeof ProtectedAdminArioRouteRoute;
    };
    '/_protected/admin/ario/workflows': {
      id: '/_protected/admin/ario/workflows';
      path: '/workflows';
      fullPath: '/admin/ario/workflows';
      preLoaderRoute: typeof ProtectedAdminArioWorkflowsRouteImport;
      parentRoute: typeof ProtectedAdminArioRouteRoute;
    };
    '/_protected/admin/automations/': {
      id: '/_protected/admin/automations/';
      path: '/automations';
      fullPath: '/admin/automations/';
      preLoaderRoute: typeof ProtectedAdminAutomationsIndexRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/admin/automations/$': {
      id: '/_protected/admin/automations/$';
      path: '/automations/$';
      fullPath: '/admin/automations/$';
      preLoaderRoute: typeof ProtectedAdminAutomationsSplatRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/admin/inspector_/$conversationId': {
      id: '/_protected/admin/inspector_/$conversationId';
      path: '/inspector/$conversationId';
      fullPath: '/admin/inspector/$conversationId';
      preLoaderRoute: typeof ProtectedAdminInspectorConversationIdRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/admin/users_/onboarding': {
      id: '/_protected/admin/users_/onboarding';
      path: '/users/onboarding';
      fullPath: '/admin/users/onboarding';
      preLoaderRoute: typeof ProtectedAdminUsersOnboardingRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/admin/users_/organisations': {
      id: '/_protected/admin/users_/organisations';
      path: '/users/organisations';
      fullPath: '/admin/users/organisations';
      preLoaderRoute: typeof ProtectedAdminUsersOrganisationsRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/admin/users_/staff': {
      id: '/_protected/admin/users_/staff';
      path: '/users/staff';
      fullPath: '/admin/users/staff';
      preLoaderRoute: typeof ProtectedAdminUsersStaffRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/admin/users_/subscribers': {
      id: '/_protected/admin/users_/subscribers';
      path: '/users/subscribers';
      fullPath: '/admin/users/subscribers';
      preLoaderRoute: typeof ProtectedAdminUsersSubscribersRouteImport;
      parentRoute: typeof ProtectedAdminRouteRoute;
    };
    '/_protected/insights/operator/$slug': {
      id: '/_protected/insights/operator/$slug';
      path: '/insights/operator/$slug';
      fullPath: '/insights/operator/$slug';
      preLoaderRoute: typeof ProtectedInsightsOperatorSlugRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    '/_protected/admin/ario/runs_/$runId': {
      id: '/_protected/admin/ario/runs_/$runId';
      path: '/runs/$runId';
      fullPath: '/admin/ario/runs/$runId';
      preLoaderRoute: typeof ProtectedAdminArioRunsRunIdRouteImport;
      parentRoute: typeof ProtectedAdminArioRouteRoute;
    };
    '/_protected/admin/ario/workflows_/$workflowId': {
      id: '/_protected/admin/ario/workflows_/$workflowId';
      path: '/workflows/$workflowId';
      fullPath: '/admin/ario/workflows/$workflowId';
      preLoaderRoute: typeof ProtectedAdminArioWorkflowsWorkflowIdRouteImport;
      parentRoute: typeof ProtectedAdminArioRouteRoute;
    };
  }
}

interface ProtectedAdminArioRouteRouteChildren {
  ProtectedAdminArioChatRoute: typeof ProtectedAdminArioChatRoute;
  ProtectedAdminArioCollectorsRoute: typeof ProtectedAdminArioCollectorsRoute;
  ProtectedAdminArioNewsRoute: typeof ProtectedAdminArioNewsRoute;
  ProtectedAdminArioOutputsRoute: typeof ProtectedAdminArioOutputsRoute;
  ProtectedAdminArioProcessorsRoute: typeof ProtectedAdminArioProcessorsRoute;
  ProtectedAdminArioRunsRoute: typeof ProtectedAdminArioRunsRoute;
  ProtectedAdminArioSchedulesRoute: typeof ProtectedAdminArioSchedulesRoute;
  ProtectedAdminArioSourcesRoute: typeof ProtectedAdminArioSourcesRoute;
  ProtectedAdminArioWorkflowsRoute: typeof ProtectedAdminArioWorkflowsRoute;
  ProtectedAdminArioIndexRoute: typeof ProtectedAdminArioIndexRoute;
  ProtectedAdminArioRunsRunIdRoute: typeof ProtectedAdminArioRunsRunIdRoute;
  ProtectedAdminArioWorkflowsWorkflowIdRoute: typeof ProtectedAdminArioWorkflowsWorkflowIdRoute;
}

const ProtectedAdminArioRouteRouteChildren: ProtectedAdminArioRouteRouteChildren =
  {
    ProtectedAdminArioChatRoute: ProtectedAdminArioChatRoute,
    ProtectedAdminArioCollectorsRoute: ProtectedAdminArioCollectorsRoute,
    ProtectedAdminArioNewsRoute: ProtectedAdminArioNewsRoute,
    ProtectedAdminArioOutputsRoute: ProtectedAdminArioOutputsRoute,
    ProtectedAdminArioProcessorsRoute: ProtectedAdminArioProcessorsRoute,
    ProtectedAdminArioRunsRoute: ProtectedAdminArioRunsRoute,
    ProtectedAdminArioSchedulesRoute: ProtectedAdminArioSchedulesRoute,
    ProtectedAdminArioSourcesRoute: ProtectedAdminArioSourcesRoute,
    ProtectedAdminArioWorkflowsRoute: ProtectedAdminArioWorkflowsRoute,
    ProtectedAdminArioIndexRoute: ProtectedAdminArioIndexRoute,
    ProtectedAdminArioRunsRunIdRoute: ProtectedAdminArioRunsRunIdRoute,
    ProtectedAdminArioWorkflowsWorkflowIdRoute:
      ProtectedAdminArioWorkflowsWorkflowIdRoute,
  };

const ProtectedAdminArioRouteRouteWithChildren =
  ProtectedAdminArioRouteRoute._addFileChildren(
    ProtectedAdminArioRouteRouteChildren,
  );

interface ProtectedAdminRouteRouteChildren {
  ProtectedAdminArioRouteRoute: typeof ProtectedAdminArioRouteRouteWithChildren;
  ProtectedAdminFeedbackRoute: typeof ProtectedAdminFeedbackRoute;
  ProtectedAdminFilesRoute: typeof ProtectedAdminFilesRoute;
  ProtectedAdminInspectorRoute: typeof ProtectedAdminInspectorRoute;
  ProtectedAdminInviteRoute: typeof ProtectedAdminInviteRoute;
  ProtectedAdminUploadRoute: typeof ProtectedAdminUploadRoute;
  ProtectedAdminUsageRoute: typeof ProtectedAdminUsageRoute;
  ProtectedAdminUsersRoute: typeof ProtectedAdminUsersRoute;
  ProtectedAdminIndexRoute: typeof ProtectedAdminIndexRoute;
  ProtectedAdminAutomationsSplatRoute: typeof ProtectedAdminAutomationsSplatRoute;
  ProtectedAdminInspectorConversationIdRoute: typeof ProtectedAdminInspectorConversationIdRoute;
  ProtectedAdminUsersOnboardingRoute: typeof ProtectedAdminUsersOnboardingRoute;
  ProtectedAdminUsersOrganisationsRoute: typeof ProtectedAdminUsersOrganisationsRoute;
  ProtectedAdminUsersStaffRoute: typeof ProtectedAdminUsersStaffRoute;
  ProtectedAdminUsersSubscribersRoute: typeof ProtectedAdminUsersSubscribersRoute;
  ProtectedAdminAutomationsIndexRoute: typeof ProtectedAdminAutomationsIndexRoute;
}

const ProtectedAdminRouteRouteChildren: ProtectedAdminRouteRouteChildren = {
  ProtectedAdminArioRouteRoute: ProtectedAdminArioRouteRouteWithChildren,
  ProtectedAdminFeedbackRoute: ProtectedAdminFeedbackRoute,
  ProtectedAdminFilesRoute: ProtectedAdminFilesRoute,
  ProtectedAdminInspectorRoute: ProtectedAdminInspectorRoute,
  ProtectedAdminInviteRoute: ProtectedAdminInviteRoute,
  ProtectedAdminUploadRoute: ProtectedAdminUploadRoute,
  ProtectedAdminUsageRoute: ProtectedAdminUsageRoute,
  ProtectedAdminUsersRoute: ProtectedAdminUsersRoute,
  ProtectedAdminIndexRoute: ProtectedAdminIndexRoute,
  ProtectedAdminAutomationsSplatRoute: ProtectedAdminAutomationsSplatRoute,
  ProtectedAdminInspectorConversationIdRoute:
    ProtectedAdminInspectorConversationIdRoute,
  ProtectedAdminUsersOnboardingRoute: ProtectedAdminUsersOnboardingRoute,
  ProtectedAdminUsersOrganisationsRoute: ProtectedAdminUsersOrganisationsRoute,
  ProtectedAdminUsersStaffRoute: ProtectedAdminUsersStaffRoute,
  ProtectedAdminUsersSubscribersRoute: ProtectedAdminUsersSubscribersRoute,
  ProtectedAdminAutomationsIndexRoute: ProtectedAdminAutomationsIndexRoute,
};

const ProtectedAdminRouteRouteWithChildren =
  ProtectedAdminRouteRoute._addFileChildren(ProtectedAdminRouteRouteChildren);

interface ProtectedChatRouteRouteChildren {
  ProtectedChatConversationIdRoute: typeof ProtectedChatConversationIdRoute;
}

const ProtectedChatRouteRouteChildren: ProtectedChatRouteRouteChildren = {
  ProtectedChatConversationIdRoute: ProtectedChatConversationIdRoute,
};

const ProtectedChatRouteRouteWithChildren =
  ProtectedChatRouteRoute._addFileChildren(ProtectedChatRouteRouteChildren);

interface ProtectedRestrictedRouteRouteChildren {
  ProtectedRestrictedExperimentsRoute: typeof ProtectedRestrictedExperimentsRoute;
  ProtectedRestrictedIndexRoute: typeof ProtectedRestrictedIndexRoute;
}

const ProtectedRestrictedRouteRouteChildren: ProtectedRestrictedRouteRouteChildren =
  {
    ProtectedRestrictedExperimentsRoute: ProtectedRestrictedExperimentsRoute,
    ProtectedRestrictedIndexRoute: ProtectedRestrictedIndexRoute,
  };

const ProtectedRestrictedRouteRouteWithChildren =
  ProtectedRestrictedRouteRoute._addFileChildren(
    ProtectedRestrictedRouteRouteChildren,
  );

interface ProtectedRouteRouteChildren {
  ProtectedAdminRouteRoute: typeof ProtectedAdminRouteRouteWithChildren;
  ProtectedChatRouteRoute: typeof ProtectedChatRouteRouteWithChildren;
  ProtectedRestrictedRouteRoute: typeof ProtectedRestrictedRouteRouteWithChildren;
  ProtectedAccountRoute: typeof ProtectedAccountRoute;
  ProtectedNewsRoute: typeof ProtectedNewsRoute;
  ProtectedReportsRoute: typeof ProtectedReportsRoute;
  ProtectedUpdatesRoute: typeof ProtectedUpdatesRoute;
  ProtectedIndexRoute: typeof ProtectedIndexRoute;
  ProtectedArtifactArtifactIdRoute: typeof ProtectedArtifactArtifactIdRoute;
  ProtectedOperatorsSlugRoute: typeof ProtectedOperatorsSlugRoute;
  ProtectedRegionsSlugRoute: typeof ProtectedRegionsSlugRoute;
  ProtectedInsightsIndexRoute: typeof ProtectedInsightsIndexRoute;
  ProtectedOperatorsIndexRoute: typeof ProtectedOperatorsIndexRoute;
  ProtectedRegionsIndexRoute: typeof ProtectedRegionsIndexRoute;
  ProtectedInsightsOperatorSlugRoute: typeof ProtectedInsightsOperatorSlugRoute;
}

const ProtectedRouteRouteChildren: ProtectedRouteRouteChildren = {
  ProtectedAdminRouteRoute: ProtectedAdminRouteRouteWithChildren,
  ProtectedChatRouteRoute: ProtectedChatRouteRouteWithChildren,
  ProtectedRestrictedRouteRoute: ProtectedRestrictedRouteRouteWithChildren,
  ProtectedAccountRoute: ProtectedAccountRoute,
  ProtectedNewsRoute: ProtectedNewsRoute,
  ProtectedReportsRoute: ProtectedReportsRoute,
  ProtectedUpdatesRoute: ProtectedUpdatesRoute,
  ProtectedIndexRoute: ProtectedIndexRoute,
  ProtectedArtifactArtifactIdRoute: ProtectedArtifactArtifactIdRoute,
  ProtectedOperatorsSlugRoute: ProtectedOperatorsSlugRoute,
  ProtectedRegionsSlugRoute: ProtectedRegionsSlugRoute,
  ProtectedInsightsIndexRoute: ProtectedInsightsIndexRoute,
  ProtectedOperatorsIndexRoute: ProtectedOperatorsIndexRoute,
  ProtectedRegionsIndexRoute: ProtectedRegionsIndexRoute,
  ProtectedInsightsOperatorSlugRoute: ProtectedInsightsOperatorSlugRoute,
};

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(
  ProtectedRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  ProtectedRouteRoute: ProtectedRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  RequestAccessRoute: RequestAccessRoute,
  StylePreviewRoute: StylePreviewRoute,
  WaitingRoute: WaitingRoute,
  ClaimTokenRoute: ClaimTokenRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
